import React, { useEffect, useRef } from "react";
import ace from "ace-builds/src-noconflict/ace";
import cssUrl from "ace-builds/src-noconflict/mode-css?url";
import htmlUrl from "ace-builds/src-noconflict/mode-html?url";

ace.config.setModuleUrl("ace/mode/css", cssUrl);
ace.config.setModuleUrl("ace/mode/html", htmlUrl);

export function CodeInput({ code, value, onChange }) {
  let ref = useRef();
  useEffect(() => {
    var editor = ace.edit(ref.current);
    //editor.setTheme("ace/theme/monokai");

    if (code.language == "css") editor.session.setMode("ace/mode/css");
    else editor.session.setMode("ace/mode/html");

    editor.setValue(value);
    editor.on("change", (e) => {
      onChange(editor.getValue());
    });
  }, []);
  return (
    <div ref={ref} className={"h-full border border-gray-200 rounded"}></div>
  );
}
